import React, { useState, useEffect } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Termscondtion from "../../components/terms/terms_conditions";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const Terms = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);
  useEffect(() => {
    const start = Date.now();

    const spinnerTimeout = setTimeout(() => {
      setShowSpinner(true);
    }, 500);

    const fetchTimeout = setTimeout(() => {
      setLoading(false);
      const elapsed = Date.now() - start;
      if (elapsed < 500) {
        clearTimeout(spinnerTimeout);
      }
    }, 2000);

    return () => {
      clearTimeout(spinnerTimeout);
      clearTimeout(fetchTimeout);
    };
  }, []);
  return (
    <>
      {loading ? (
        showSpinner && <Spinner />
      ) : (
        <div class="container-lg">
          <Termscondtion />
        </div>
      )}
    </>
  );
};

export default Terms;
